import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "",
  style: {"overflow":"auto"}
}
const _hoisted_2 = {
  class: "table table-striped",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "text-start p-sm" }
const _hoisted_4 = { class: "text-start p-sm" }
const _hoisted_5 = { class: "text-start p-sm" }
const _hoisted_6 = { class: "text-start p-sm" }
const _hoisted_7 = { class: "text-start p-sm" }
const _hoisted_8 = { class: "text-start p-sm" }
const _hoisted_9 = { class: "text-start p-sm" }
const _hoisted_10 = { class: "text-start p-sm" }
const _hoisted_11 = { class: "text-start p-sm" }
const _hoisted_12 = { class: "text-start p-sm" }
const _hoisted_13 = { class: "text-start p-sm" }
const _hoisted_14 = { class: "text-start p-sm" }
const _hoisted_15 = { class: "text-start p-sm" }
const _hoisted_16 = { class: "p-sm" }
const _hoisted_17 = { class: "d-flex align-items-center gap-2" }
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "p-sm" }
const _hoisted_20 = ["title"]
const _hoisted_21 = { class: "p-sm" }
const _hoisted_22 = { class: "p-sm" }
const _hoisted_23 = { class: "p-sm" }
const _hoisted_24 = { class: "p-sm" }
const _hoisted_25 = { class: "p-sm" }
const _hoisted_26 = { class: "p-sm" }
const _hoisted_27 = { class: "p-sm" }
const _hoisted_28 = { class: "p-sm" }
const _hoisted_29 = { class: "p-sm" }
const _hoisted_30 = {
  key: 0,
  class: "badge bg-danger"
}
const _hoisted_31 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_32 = { class: "p-sm" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_35 = { class: "p-sm" }
const _hoisted_36 = { class: "text-end p-sm" }
const _hoisted_37 = { class: "d-flex gap-2 justify-content-end align-items-center" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  colspan: "14",
  class: "text-center py-5"
}
const _hoisted_43 = { style: {"display":"flex","flex-direction":"column","align-items":"center","gap":"12px","padding":"40px 20px"} }
const _hoisted_44 = {
  width: "64",
  height: "64",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {"opacity":"0.4"}
}
const _hoisted_45 = { style: {"font-size":"16px","color":"#6c757d","font-weight":"500"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_BanUserPopup = _resolveComponent("BanUserPopup")!
  const _component_ReattachRequisitePopup = _resolveComponent("ReattachRequisitePopup")!
  const _component_Popup = _resolveComponent("Popup")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "popup__xl",
    title: _ctx.helper.trans('labels.counterparty_statistics'),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderContent, {
        ref: "loader",
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.user_id')), 1),
                  _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.store_hash')), 1),
                  _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.use_count')), 1),
                  _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.completed_count')), 1),
                  _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.total_completed')), 1),
                  _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.total_use_count')), 1),
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.conversion_rate')), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.total_conversion_rate')), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.average_check')), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.days_since_last_use')), 1),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.helper.trans('labels.is_banned')), 1),
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.helper.trans('labels.first_used_at')), 1),
                  _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.helper.trans('labels.last_used_at')), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.counterparties, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: index,
                    class: ""
                  }, [
                    _createElementVNode("td", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives((_openBlock(), _createElementBlock("span", {
                          title: item.userId
                        }, [
                          _createTextVNode(_toDisplayString(item.userId.substring(0, 8)) + "...", 1)
                        ], 8, _hoisted_18)), [
                          [
                            _directive_b_tooltip,
                            void 0,
                            void 0,
                            { hover: true }
                          ]
                        ]),
                        _createVNode(_component_copy_button, {
                          value: item.userId
                        }, null, 8, ["value"])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_19, [
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        title: item.storeHash
                      }, [
                        _createTextVNode(_toDisplayString(item.storeHash ? item.storeHash.substring(0, 12) + '…' : '—'), 1)
                      ], 8, _hoisted_20)), [
                        [
                          _directive_b_tooltip,
                          void 0,
                          void 0,
                          { hover: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.numberFormatter.formatNumber(item.useCount)), 1),
                    _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.numberFormatter.formatNumber(item.completedCount)), 1),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.numberFormatter.formatNumber(item.totalCompleted ?? item.completedCount)), 1),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(item.totalUseCount != null ? _ctx.numberFormatter.formatNumber(item.totalUseCount) : '—'), 1),
                    _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.numberFormatter.formatNumber(item.conversionRate, 2)) + "%", 1),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(item.totalConversionRate != null ? _ctx.numberFormatter.formatNumber(item.totalConversionRate, 2) + '%' : '—'), 1),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(_ctx.numberFormatter.formatNumber(Number.parseFloat(item.averageCheck), 2)), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.numberFormatter.formatNumber(item.daysSinceLastUse)), 1),
                    _createElementVNode("td", _hoisted_29, [
                      (item.isBanned)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.helper.trans('labels.banned')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_31, "—"))
                    ]),
                    _createElementVNode("td", _hoisted_32, [
                      (item.firstUsedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.dateHelper.format(item.firstUsedAt, 'YYYY-MM-DD')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_34, "-"))
                    ]),
                    _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.dateHelper.format(item.lastUsedAt, 'YYYY-MM-DD')), 1),
                    _createElementVNode("td", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        (!item.isBanned && item.storeHash)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              onClick: ($event: any) => (_ctx.openBanPopup(item)),
                              class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize-first"
                            }, _toDisplayString(_ctx.helper.trans('button.ban')), 9, _hoisted_38))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (_ctx.handleReattachClick(item.userId)),
                          class: "btn btn-sm btn-outline-primary text-nowrap text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('labels.reattach')), 9, _hoisted_39),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: ($event: any) => (_ctx.confirmDeleteCounterparty(item.userId)),
                          class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize-first"
                        }, _toDisplayString(_ctx.helper.trans('button.unlink')), 9, _hoisted_40)
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.counterparties.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_41, [
                      _createElementVNode("td", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          (_openBlock(), _createElementBlock("svg", _hoisted_44, _cache[1] || (_cache[1] = [
                            _createElementVNode("path", {
                              d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
                              fill: "currentColor"
                            }, null, -1)
                          ]))),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.helper.trans('labels.no_history')), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_ConfirmPopup, { ref: "confirmPopup" }, null, 512),
      _createVNode(_component_BanUserPopup, {
        ref: "banUserPopup",
        onBanned: _ctx.onBanned
      }, null, 8, ["onBanned"]),
      _createVNode(_component_ReattachRequisitePopup, {
        ref: "reattachPopup",
        onSelected: _ctx.handleReattach
      }, null, 8, ["onSelected"])
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}